import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useParams } from 'react-router';

import { useAudienceById } from '@/api/audience';
import AudienceDetailEditContent from '@/app/audiences/[audience]/edit/AudienceDetailEditContent';
import Error404 from '@/components/errors/Error404';
import { PageSpinner } from '@/components/loaders';
import { Page } from '@/components/page';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';
import SolAPIError from '@/error/SolAPIError';

const AudienceDetailEdit = () => {
  const { audience: audienceId } = useParams();
  const { audience, isLoading, error } = useAudienceById(audienceId);

  if (error instanceof SolAPIError && error.is404()) {
    return <Error404 title={<Trans>The audience you're looking for does not exist</Trans>} />;
  }

  return (
    <Page title={t`Edit Audience`} exampleAIQuestions={exampleAIQuestions('audience')}>
      {isLoading ? <PageSpinner /> : audience && <AudienceDetailEditContent audience={audience} />}
    </Page>
  );
};

export default AudienceDetailEdit;
